// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IGetPostResult,
}                               from '../interfaces';

// ===== Enums =====

import {
    ZOOM_LEVEL,
}                               from '../components/Editor/elements/enums';
import {
    POST_RESPONSE_TIER,
}                               from '../enums';

const getPost = async ({
    test,
    postId,
    fullPost = false,
    zoomLevel,
    chapterId,
    sectionId,
    requestedPath,
    responseTier,
    metadataOnly,
    includeReadOnlyValueNodes,
}: {
    test: boolean,
    postId: string,
    fullPost?: boolean,
    zoomLevel?: ZOOM_LEVEL,
    chapterId?: string,
    sectionId?: string,
    requestedPath?: number[],
    responseTier?: POST_RESPONSE_TIER,
    metadataOnly?: boolean,
    includeReadOnlyValueNodes?: boolean,
}): Promise<IGetPostResult> => {
    const functions = getFunctions();
    const handleGetPost = httpsCallable<
        {
            test: boolean,
            postId: string,
            fullPost?: boolean,
            zoomLevel?: ZOOM_LEVEL,
            chapterId?: string,
            sectionId?: string,
            requestedPath?: number[],
            responseTier?: POST_RESPONSE_TIER,
            metadataOnly?: boolean,
            includeReadOnlyValueNodes?: boolean,
        },
        IGetPostResult
    >(
        functions,
        'getPost',
    );
    return handleGetPost({
        test,
        postId,
        fullPost,
        zoomLevel,
        chapterId,
        sectionId,
        requestedPath,
        responseTier,
        metadataOnly,
        includeReadOnlyValueNodes,
    }).then((result) => {
        const partialPost = result.data as IGetPostResult;
        return partialPost;
    }).catch((err) => {
        throw err;
    });
};

export default getPost;
